(function(){
function init(root){
var items=[].slice.call(root.querySelectorAll('[data-avl-s]')),
      days=[].slice.call(root.querySelectorAll('[data-avl-day]')),
      chips=[].slice.call(root.querySelectorAll('[data-avl-f]')),
      q=root.querySelector('[data-avl-q]'), cnt=root.querySelector('[data-avl-count]'),
      empty=root.querySelector('[data-avl-empty]'), tog=root.querySelector('[data-avl-toggle]'),
      filter='all', total=items.length;
  if(!q) return;
  function apply(){
    var term=(q.value||'').trim().toLowerCase(), words=term?term.split(/\s+/):[], shown=0;
    items.forEach(function(el){
      var ok=true;
      if(filter.indexOf('day:')===0) ok=el.dataset.day===filter.slice(4);
      else if(filter.indexOf('cat:')===0) ok=el.dataset.cat===filter.slice(4);
      if(ok&&words.length){var t=el.dataset.text;for(var i=0;i<words.length;i++){if(t.indexOf(words[i])<0){ok=false;break;}}}
      el.hidden=!ok; if(ok) shown++;
    });
    days.forEach(function(d){d.hidden=!d.querySelector('[data-avl-s]:not([hidden])');});
    cnt.textContent='Showing '+shown+' of '+total+' sessions';
    empty.hidden=shown>0;
  }
  chips.forEach(function(c){c.addEventListener('click',function(){
    filter=c.dataset.avlF; chips.forEach(function(x){x.setAttribute('aria-pressed',x===c);}); apply();
  });});
  q.addEventListener('input',apply);
  tog.addEventListener('click',function(){
    var open=tog.dataset.open!=='1';
    items.forEach(function(el){if(!el.hidden) el.open=open;});
    tog.dataset.open=open?'1':'0'; tog.textContent=open?'Collapse all':'Expand all';
  });
  items.forEach(function(el){el.addEventListener('toggle',function(){
    if(!el.open) return; var p=el.querySelector('[data-avl-embed]'); if(!p||p.firstChild) return;
    var f=document.createElement('iframe'); f.src=p.dataset.avlEmbed; f.title=p.dataset.avlTitle;
    f.allow='autoplay; fullscreen; picture-in-picture'; f.allowFullscreen=true; f.loading='lazy'; p.appendChild(f);
  });});
  var bar=root.querySelector('[data-avl-bar]'), hero=root.querySelector('.avl-hero .avl-buyform'), buy=root.querySelector('[data-avl-buy]');
  if(bar&&hero&&buy&&'IntersectionObserver' in window){
    var heroVis=true,buyVis=false;
    function upd(){var on=!heroVis&&!buyVis;bar.classList.toggle('on',on);bar.setAttribute('aria-hidden',!on);}
    new IntersectionObserver(function(e){heroVis=e[0].isIntersecting;upd();}).observe(hero);
    new IntersectionObserver(function(e){buyVis=e[0].isIntersecting;upd();}).observe(buy);
  }
}
document.querySelectorAll('.avl').forEach(init);
document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.avl');if(r)init(r);});
})();